import * as SHORTEN_URL from './shorten.graphql'
import * as LOOKUP_SHORTENED_URL from './redirect.graphql'

export {SHORTEN_URL, LOOKUP_SHORTENED_URL}
export * from './ShortenerStore'



// WEBPACK FOOTER //
// ./src/modules/common/graphql/shortener/index.ts